export default "__VITE_ASSET__5e65f082__"